import React, {Component} from 'react'
import {RM, Button} from './../../../../components'
import {QuizzStyle} from './../../../../styles'

export default class Intro extends Component {
  state = {
    
  }

  handlerClick = async() => {
    await this.props.startQuizz()
  }

  render () {
    const {date_end, date_start, questions, title, alreadyPlayed, enabled, current} = this.props
    return (
      <div className={`quizz-intro quizz ${QuizzStyle}`}>
        <div className="quizz-title">
          <RM width={228} height={92} /> Challenge
        </div>
        <div className="quizz-container">
          <div className="quizz-subtitle quizz-up">
            {title}
          </div>
          <div className="quizz-date flex">
            <div className="quizz-start quizz-up">
              Start : <span className="date">{date_start}</span>
            </div>
            <div className="quizz-end quizz-up">
              End : <span className="date">{date_end}</span>
            </div>
          </div>

          <p className="quizz-description">This test will have {questions} questions, spread in the following themes. The test will be limited in time and every question will have a proper time</p>

          <Button theme="red" onCallback={this.handlerClick} > {alreadyPlayed ? 'restart' : 'start'} </Button>
          
          {/* { enabled && !current && 
            <Button theme="red" onCallback={this.handlerClick} > {alreadyPlayed ? 'restart' : 'start'} </Button>
          }
          
          { enabled && current && !alreadyPlayed && 
            <Button theme="red" onCallback={this.handlerClick} > {alreadyPlayed ? 'restart' : 'start'} </Button>
          } */}
          
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Quizz/Intro.js